import React, { useEffect, useState } from "react";
import { CaseStudy_IMAGES_API } from "../../../../../../Utilities/APIs";
import Image from "../../../../../Partials/Elements/Image/Image";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import Video from "../../../../../Partials/Elements/Video/Video";

function ViewCaseStudyImage({ targetID }) {
  const [CaseStudyInfo, setCaseStudyInfo] = useState(null);
  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    async function fetchAndSetCaseStudyInfo() {
      const { data } = await axiosInstance.get(CaseStudy_IMAGES_API + targetID);
      setCaseStudyInfo(data);
    }
    fetchAndSetCaseStudyInfo();
  }, [targetID, axiosInstance]);

  return (
    <div className="crud_view_content">
      {CaseStudyInfo && (
        <>
          <h1>Card Image</h1>
          <Image imgLink={CaseStudyInfo.image} imgAlt={"Image"} />
          <h1> Video</h1>
          {CaseStudyInfo.video ? (
            <Video src={CaseStudyInfo.video} />
          ) : (
            "No Video"
          )}
        </>
      )}
    </div>
  );
}

export default ViewCaseStudyImage;
